import { PayloadAction } from '@reduxjs/toolkit';
import { initialState } from '.';

export const reducers = {
  setMountingPlate(state, action: PayloadAction<any>) {
    state.isLoading = true;
  },
  setMountingPlateSuccess(state, action: PayloadAction<any>) {
    state.isLoading = false;
    state.data = action.payload;
    state.error = null;
  },
  setMountingPlateFailure(state, action: PayloadAction<any>) {
    state.isLoading = false;
    state.data = initialState.data;
    state.error = action.payload;
  },
};
